export const idaho = {
  "16000": "Idaho",
  "16001": "Ada County",
  "16003": "Adams County",
  "16005": "Bannock County",
  "16007": "Bear Lake County",
  "16009": "Benewah County",
  "16011": "Bingham County",
  "16013": "Blaine County",
  "16015": "Boise County",
  "16017": "Bonner County",
  "16019": "Bonneville County",
  "16021": "Boundary County",
  "16023": "Butte County",
  "16025": "Camas County",
  "16027": "Canyon County",
  "16029": "Caribou County",
  "16031": "Cassia County",
  "16033": "Clark County",
  "16035": "Clearwater County",
  "16037": "Custer County",
  "16039": "Elmore County",
  "16041": "Franklin County",
  "16043": "Fremont County",
  "16045": "Gem County",
  "16047": "Gooding County",
  "16049": "Idaho County",
  "16051": "Jefferson County",
  "16053": "Jerome County",
  "16055": "Kootenai County",
  "16057": "Latah County",
  "16059": "Lemhi County",
  "16061": "Lewis County",
  "16063": "Lincoln County",
  "16065": "Madison County",
  "16067": "Minidoka County",
  "16069": "Nez Perce County",
  "16071": "Oneida County",
  "16073": "Owyhee County",
  "16075": "Payette County",
  "16077": "Power County",
  "16079": "Shoshone County",
  "16081": "Teton County",
  "16083": "Twin Falls County",
  "16085": "Valley County",
  "16087": "Washington County",
};
